import React from 'react';
import { useSelector } from 'react-redux';
import { Smartphone, Check, ArrowRight } from 'lucide-react';
import 'bootstrap/dist/css/bootstrap.min.css';

const ManpowerServices = ({ topDataa }) => {
  const { language } = useSelector((state) => state.language);

  const translations = {
    gb: {
      topData: {
        title: topDataa?.title || 'Hello',
        description: topDataa?.description || 'yes',
        subtitle: 'Services',
      },
      cardData: [
        {
          title: 'Skilled Labor',
          description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam commodo mi orci, id commodo diam sodales vitae.',
          button: 'View More',
        },
        {
          title: 'Technical Staff',
          description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam commodo mi orci, id commodo diam sodales vitae.',
          button: 'View More',
        },
        {
          title: 'Administrative',
          description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam commodo mi orci, id commodo diam sodales vitae.',
          button: 'View More',
        },
        {
          title: 'General Labor',
          description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam commodo mi orci, id commodo diam sodales vitae.',
          button: 'View More',
        },
        {
          title: 'Specialized Labor',
          description: '',
          button: 'View More',
          points: [
            'Efficient and reliable workforce',
            'Safety training and compliance',
            'Flexible working hours',
          ],
        },
        {
          title: 'Specialized Labor',
          description: '',
          button: 'View More',
          points: [
            'Efficient and reliable workforce',
            'Safety training and compliance',
            'Flexible working hours',
          ],
        },
      ],
    },
    sa: {
      topData: {
        title: topDataa?.title || 'مرحباً',
        description: topDataa?.description || 'نعم',
        subtitle: 'الخدمات',
      },
      cardData: [
        {
          title: 'العمالة الماهرة',
          description:
            'لوريم إيبسوم دولور سيت أميت، كونسيكتيتور أديبيسسينغ إليت. نولام كومودو مي أوركي، إد كومودو ديام سوداليس فيتاي.',
          button: 'عرض المزيد',
        },
        {
          title: 'الطاقم الفني',
          description:
            'لوريم إيبسوم دولور سيت أميت، كونسيكتيتور أديبيسسينغ إليت. نولام كومودو مي أوركي، إد كومودو ديام سوداليس فيتاي.',
          button: 'عرض المزيد',
        },
        {
          title: 'الإداري',
          description:
            'لوريم إيبسوم دولور سيت أميت، كونسيكتيتور أديبيسسينغ إليت. نولام كومودو مي أوركي، إد كومودو ديام سوداليس فيتاي.',
          button: 'عرض المزيد',
        },
        {
          title: 'العمالة العامة',
          description:
            'لوريم إيبسوم دولور سيت أميت، كونسيكتيتور أديبيسسينغ إليت. نولام كومودو مي أوركي، إد كومودو ديام سوداليس فيتاي.',
          button: 'عرض المزيد',
        },
        {
          title: 'العمالة المتخصصة',
          description: '',
          button: 'عرض المزيد',
          points: [
            'قوى عاملة فعالة وموثوقة',
            'تدريب السلامة والامتثال',
            'ساعات عمل مرنة',
          ],
        },
        {
          title: 'العمالة المتخصصة',
          description: '',
          button: 'عرض المزيد',
          points: [
            'قوى عاملة فعالة وموثوقة',
            'تدريب السلامة والامتثال',
            'ساعات عمل مرنة',
          ],
        },
      ],
    },
    fr: {
      topData: {
        title: topDataa?.title || 'Bonjour',
        description: topDataa?.description || 'Oui',
        subtitle: 'Services',
      },
      cardData: [
        {
          title: 'Main-d\'œuvre qualifiée',
          description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam commodo mi orci, id commodo diam sodales vitae.',
          button: 'Voir plus',
        },
        {
          title: 'Personnel technique',
          description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam commodo mi orci, id commodo diam sodales vitae.',
          button: 'Voir plus',
        },
        {
          title: 'Administratif',
          description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam commodo mi orci, id commodo diam sodales vitae.',
          button: 'Voir plus',
        },
        {
          title: 'Main-d\'œuvre générale',
          description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam commodo mi orci, id commodo diam sodales vitae.',
          button: 'Voir plus',
        },
        {
          title: 'Main-d\'œuvre spécialisée',
          description: '',
          button: 'Voir plus',
          points: [
            'Main-d\'œuvre efficace et fiable',
            'Formation à la sécurité et conformité',
            'Horaires de travail flexibles',
          ],
        },
        {
          title: 'Main-d\'œuvre spécialisée',
          description: '',
          button: 'Voir plus',
          points: [
            'Main-d\'œuvre efficace et fiable',
            'Formation à la sécurité et conformité',
            'Horaires de travail flexibles',
          ],
        },
      ],
    },
    de: {
      topData: {
        title: topDataa?.title || 'Hallo',
        description: topDataa?.description || 'Ja',
        subtitle: 'Dienstleistungen',
      },
      cardData: [
        {
          title: 'Fachkräfte',
          description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam commodo mi orci, id commodo diam sodales vitae.',
          button: 'Mehr anzeigen',
        },
        {
          title: 'Technisches Personal',
          description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam commodo mi orci, id commodo diam sodales vitae.',
          button: 'Mehr anzeigen',
        },
        {
          title: 'Verwaltung',
          description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam commodo mi orci, id commodo diam sodales vitae.',
          button: 'Mehr anzeigen',
        },
        {
          title: 'Allgemeine Arbeitskräfte',
          description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam commodo mi orci, id commodo diam sodales vitae.',
          button: 'Mehr anzeigen',
        },
        {
          title: 'Spezialisierte Arbeitskräfte',
          description: '',
          button: 'Mehr anzeigen',
          points: [
            'Effiziente und zuverlässige Arbeitskräfte',
            'Sicherheitsschulung und Compliance',
            'Flexible Arbeitszeiten',
          ],
        },
        {
          title: 'Spezialisierte Arbeitskräfte',
          description: '',
          button: 'Mehr anzeigen',
          points: [
            'Effiziente und zuverlässige Arbeitskräfte',
            'Sicherheitsschulung und Compliance',
            'Flexible Arbeitszeiten',
          ],
        },
      ],
    },
  };

  const t = translations[language] || translations.gb;

  return (
    
    <section className="py-5">
      <div className="container px-3">
        <div className="text-center mb-12">
          <h1 className="fw-bold display-4 display-md-3 display-lg-2 mb-4">
            <span className="text-blue-600">{t.topData.title}</span> {t.topData.subtitle}
            <div className="d-flex justify-content-center mt-2">
              <div
                style={{
                  width: '40px',
                  height: '3px',
                  backgroundColor: '#c8102e',
                }}
              ></div>
              <div
                style={{
                  width: '5px',
                  height: '3px',
                  backgroundColor: '#c8102e',
                  margin: '0 4px',
                }}
              ></div>
              <div
                style={{
                  width: '40px',
                  height: '3px',
                  backgroundColor: '#c8102e',
                }}
              ></div>
            </div>
          </h1>
          <p className="text-gray-600 mx-auto mt-2" style={{ width: '50%' }}>
            {t.topData.description}
          </p>
        </div>

        <div className="row g-4 px-4">
          {t.cardData.map((card, index) => (
            <div className="col-12 col-md-6 col-lg-4" key={index}>
              <div className="card h-100 shadow-sm border-0 animated-card">
                <div className="card-body p-4 d-flex flex-column">
                  <div
                    className="mx-auto mb-3 d-flex justify-content-center align-items-center animated-icon"
                    style={{
                      width: 50,
                      height: 50,
                      background: 'linear-gradient(135deg, #FF848B, #C42F2F)',
                      borderRadius: '20px',
                    }}
                  >
                    <Smartphone size={40} className="text-white mx-auto" />
                  </div>
                  <h5 className="card-title text-center mb-3 animated-title">
                    {card.title}
                  </h5>

                  {card.description && (
                    <p className="card-text text-center text-muted small mb-4">
                      {card.description}
                    </p>
                  )}

                  {card.points && (
                    <ul className="list-unstyled mb-4 text-center">
                      {card.points.map((point, i) => (
                        <li
                          key={i}
                          className="d-flex align-items-center mb-2 animated-point"
                        >
                          <Check size={16} className="text-success me-2" />
                          <span className="small">{point}</span>
                        </li>
                      ))}
                    </ul>
                  )}

                  <button
                    className="btn btn-outline-dark rounded-pill mt-auto align-self-center d-flex align-items-center animated-button"
                    style={{
                      padding: '0.375rem 1rem',
                      fontWeight: '500',
                    }}
                  >
                    {card.button}
                    <span
                      className="ms-2 d-inline-flex align-items-center justify-content-center animated-arrow"
                      style={{
                        backgroundColor: '#C42F2F',
                        borderRadius: '50%',
                        width: '24px',
                        height: '24px',
                      }}
                    >
                      <ArrowRight size={14} color="white" />
                    </span>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <style jsx>{`
          /* Card Animation */
          .animated-card {
            transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
            transform: perspective(1000px) rotateX(0) rotateY(0) scale(1);
            transform-style: preserve-3d;
            will-change: transform;
            border-radius: 12px;
            overflow: hidden;
          }
          
          .animated-card:hover {
            transform: perspective(1000px) rotateX(2deg) rotateY(2deg) scale(1.02) translateY(-8px);
            box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 
            0 10px 10px -5px rgba(0, 0, 0, 0.04);
            border: 1px solid rgba(200, 200, 200, 0.2);
          }
          
          /* Icon Animation */
          .animated-icon {
            transition: all 0.4s ease;
          }
          
          .animated-card:hover .animated-icon {
            transform: rotate(8deg) scale(1.1);
            background: linear-gradient(135deg, #C42F2F, #FF848B);
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          }
          
          /* Title Animation */
          .animated-title {
            transition: all 0.3s ease;
            position: relative;
          }
          
          .animated-card:hover .animated-title {
            color:rgb(235, 37, 37);
            transform: scale(1.05);
          }
          
          .animated-title::after {
            content: '';
            position: absolute;
            bottom: -5px;
            left: 50%;
            width: 0;
            height: 2px;
            background:rgb(235, 37, 37);
            transition: all 0.3s ease;
          }
          
          .animated-card:hover .animated-title::after {
            width: 50%;
            left: 25%;
          }
          
          /* Point Animation */
          .animated-point {
            transition: all 0.3s ease;
            opacity: 0.9;
          }
          
          .animated-card:hover .animated-point {
            transform: translateX(5px);
            opacity: 1;
          }
          
          /* Button Animation */
          .animated-button {
            transition: all 0.3s ease;
            position: relative;
            overflow: hidden;
          }
          
          .animated-card:hover .animated-button {
            background-color:rgb(217, 65, 65);
            color: white;
            border-color:rgb(235, 37, 53);
            transform: translateY(-2px);
            box-shadow: 0 4px 8px rgba(37, 99, 235, 0.2);
          }
          
          .animated-button::before {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
            transition: all 0.5s ease;
          }
          
          .animated-card:hover .animated-button::before {
            left: 100%;
          }
          
          /* Arrow Animation */
          .animated-arrow {
            transition: all 0.3s ease;
          }
          
          .animated-card:hover .animated-arrow {
            transform: translateX(4px);
            background-color:rgb(235, 37, 37);
          }
        `}</style>
      </div>
    </section>
  );
};

export default ManpowerServices;